import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';
import type { IAdjacentSensorList } from '@model/adjucentSensorList';

interface IResponse {
  data: IAdjacentSensorList;
}

export const adjasentSensorListKey = (pointId?: number) => ['adjasentSensorList', pointId];
export const adjasentSensorListFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/installation-point/${queryKey[1]}/adjacent`);

const adjasentSensorListSelect = ({ data }: AxiosResponse<IResponse>) => data?.data;

export const useAdjasentSensorListQuery = ({ pointId }: { pointId?: number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: adjasentSensorListKey(pointId),
    queryFn: adjasentSensorListFn,
    enabled: !!pointId,
    select: adjasentSensorListSelect,
    placeholderData: {
      data: {
        data: {},
      },
    },
  });
};
